<template>
	<div>
		<hr/>	
		
		<h2>Propiedades</h2>
		<br>
		<p>
			<input type="text" v-model="abuscar" placeholder="Buscar" >
		</p>
		<br>
		<router-link id='agrega' :to="{name: 'agre-propi'}">Agregar</router-link>
		<br>
		<br>

		<ul id='propiedades-lista' v-if="propiedadesTodas !=null" >
			<li v-for="propi in buscando" align="left" >	

				<strong v-on:click="lanza(propi.id, propi.nombreCompleto + ' ' +propi.dirCalle +  ' ' + propi.dirNumero +  ' Int. ' + propi.dirInterior +  ' ' + propi.dirCiudad + ' ' + propi.dirEstado + ' ' + propi.dirCodigo , propi.familia, propi.subfamilia, propi.dueno, propi.metrosCuadrados, propi.medidasYcol, propi.status, ) ">

					<p>{{propi.nombreCompleto}}</p>
					<p>Fam: {{propi.familia}}</p>
					<p>Sub familia:{{propi.subfamilia}}</p>
					<p>Tipo: {{propi.tipo}}</p>
					<p v-if="propi.status == 'RENTADO'" ><mark>Status: {{propi.status}}</mark></p>
					<p v-if="propi.status != 'RENTADO'" ><font color="blue">Status: {{propi.status}}</font></p>

					<p>Area: {{propi.metrosCuadrados}}</p>
					<p>Medidas: {{propi.medidasYcol}}</p>


				</strong>

				<button type='button' id='selector' v-on:click="lanza(propi.id, propi.nombreCompleto + ' ' +propi.dirCalle +  ' ' + propi.dirNumero +  ' Int.' + propi.dirInterior +  ' ' + propi.dirCiudad + ' ' + propi.dirEstado + ' ' + propi.dirCodigo , propi.familia, propi.subfamilia, propi.dueno, propi.metrosCuadrados, propi.medidasYcol, propi.claveCatastral ,propi.status)" >Seleccionar</button>
				<br><br>

			   	<p>
					<router-link :to="{name: 'ver-propi', params:{id:propi.id}}">Ver</router-link>

					<router-link :to="{name: 'edi-propi', params:{id:propi.id}}">Editar</router-link>
			   	</p>
  			</li>
		</ul>
		<span v-else>Cargando propiedades ...</span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Propiedades-buscar',
  mounted(){
  	this.getPropiedades();
  },
  data () {
    return {
      propiedadesTodas: null,
      abuscar:''
    }
  },
  methods:{
  	lanza: function(idProp, nombre1, familia1, subfamilia1, dueno, area, medidas, claveC, status){
  		if(status == "RENTADO"){
  			alert("Esta propiedad ya esta rentada");
  			return;
  		}

	    this.$emit('eventoP',idProp, nombre1, familia1, subfamilia1, dueno, area, medidas, claveC);
  	},
  	getPropiedades(){
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leePropiedades.php')
  		     .then((respuesta) => {
  		     	this.propiedadesTodas=respuesta.data;
  			 });
  	}
  	
  },
  computed:{
  	 	buscando: function (){
  			return this.propiedadesTodas.filter((item) => 
  				   item.nombreCompleto.toUpperCase().includes(this.abuscar.toUpperCase())
	  			|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.subfamilia.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.status.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.tipo.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.dirCalle.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  		);
  		}
  }
}
</script>

<style lang="scss">
	#propiedades-lista{
		padding:20px;
		li{
			width: 100%;
			height: 100%;
			background: #eee;
		}
	}
</style>




// WEBPACK FOOTER //
// src/Propiedades-buscar.vue